import {
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from '@mui/material';
import { InvoiceService } from 'api';
import { ResStatus } from 'api/api.types';
import { StyledButton } from 'components/Buttons';
import { LoaderFullScreen } from 'components/Loaders/LoaderFullScreen';
import { useTranslation } from 'react-i18next';
import { appToast } from 'utils/toast.utils';
import { TableData } from '../../../../invoicesTable.types';
import * as S from '../../InvoiceTableActions.css';

type Props = {
  open: boolean;
  selectedInvoices: TableData[];
  onClose: () => void;
  onSubmit: () => Promise<void>;
};

export const ConfirmExportDialog = ({
  open,
  selectedInvoices,
  onClose,
  onSubmit,
}: Props) => {
  const { loading, exportInvoice } = InvoiceService.useExportInvoice();
  const { t } = useTranslation(['misc']);

  const handleSubmit = async () => {
    try {
      const res = await exportInvoice(selectedInvoices.map((i) => i.id));

      if (res.type === 'file') {
        appToast.success(
          t('message.exportTestSuccess', { ns: 'misc' }),
          t('message.exportTestNotice', { ns: 'misc' }),
        );
        return;
      }

      if (res.data.status === ResStatus.OK) {
        const { exportedCount, totalRequested, skippedCount } = res.data.result;

        if (exportedCount === 0) {
          appToast.error(
            t('message.exportFailed', { ns: 'misc', total: totalRequested }),
          );
        } else if (skippedCount > 0) {
          appToast.warning(
            t('message.exportPartial', {
              ns: 'misc',
              exported: exportedCount,
              total: totalRequested,
            }),
          );
        } else {
          appToast.success(
            t('message.exportSuccess', {
              ns: 'misc',
              exported: exportedCount,
              total: totalRequested,
            }),
          );
        }
      }
    } finally {
      onClose();
      await onSubmit();
    }
  };

  return (
    <S.StyledDialog open={open} onClose={onClose}>
      <LoaderFullScreen loading={loading} />
      <DialogTitle>Uwaga</DialogTitle>
      <DialogContent dividers>
        <DialogContentText>
          Czy jesteś pewien że chcesz wyeksportować zaznaczone faktury? Ta
          operacja nie może być cofnięta.
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <StyledButton $primary onClick={handleSubmit}>
          Eksport
        </StyledButton>
        <StyledButton onClick={onClose}>Anuluj</StyledButton>
      </DialogActions>
    </S.StyledDialog>
  );
};
